import { track as vercel_track } from '@vercel/analytics'
import { browser } from '$app/env'

/**
 * Send one custom event to both Vercel Analytics and Google Analytics.
 *
 * `window.gtag` only exists once the visitor has accepted cookies (see analytics.svelte),
 * so events before then never reach Google — not even queued for later.
 */
export function track(event_name: string, properties?: Parameters<typeof vercel_track>[1]) {
	if (!browser) return

	try {
		vercel_track(event_name, properties)
		// gtag.js ignores plain arrays in dataLayer, so go through gtag itself. GA4 event names only
		// allow letters, digits and underscores: "Callout CTA Clicked" → "callout_cta_clicked".
		window.gtag?.('event', event_name.toLowerCase().replace(/\W+/g, '_'), properties ?? {})
	} catch {
		return
	}
}
